import { render } from "./RFIDashboard.vue?vue&type=template&id=4f4a5b94&scoped=true"
import script from "./RFIDashboard.vue?vue&type=script&lang=js"
export * from "./RFIDashboard.vue?vue&type=script&lang=js"

import "./RFIDashboard.vue?vue&type=style&index=0&id=4f4a5b94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f4a5b94"]])

export default __exports__